export const formatOptionalParams = (path: string): string => path.replace(/\?:(\w*)/g, ':$1?');
